module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/app-card-snow-672bedbdb1babe29b9c439fd34b1a22a.webp";